export default "__VITE_ASSET__d59b39cf__"